
import React, { useState } from 'react';

import { IsModemAccess, amountFormatUse, getToken, utc_local } from '../../../helpers/Helper';
import { POST_ACTIVE_SUBSCRIPTION_LIST } from '../../../helpers/url_helper';
import ReactDOM from 'react-dom/client';
import useMounted from '../../../hooks/useMounted';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const SubscriptionList = (props) => {
    const navigate = useNavigate();
    const [filter_option, setFilterOption] = useState({ startDate: '', endDate: '' });

    useMounted(() => {
        if (!IsModemAccess('active_subscriptions', 'view')) {
            toast.error('Does not permission this module');
            navigate("/admin/dashboard");
        }
        get_invoice_list()
    },[navigate])

    const get_invoice_list = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [7] },
                    { "targets": '', "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';

                    data.startDate = (filter_option.startDate) ? new Date(filter_option.startDate).getTime() : '';
                    data.endDate = (filter_option.endDate) ? new Date(filter_option.endDate).getTime() : '';

                    $.ajax({
                        "url": POST_ACTIVE_SUBSCRIPTION_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "subscriptionId" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <span className='text-primary pointer' onClick={() => { window.open('/admin/users/view/' + data.userId, '_blank'); }}>{data.userName} </span>
                            </>)
                        }
                    },
                    { "data": "userEmail" },
                    { "data": "name" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {amountFormatUse(data.amount)}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {utc_local(data.startDate)}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {utc_local(data.endDate)}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <>
                                    {data.totalIssuedCheque} / {(data.chequePrint > 0)? data.chequePrint  : <i class="bx bx-infinite"></i>}
                                </>
                                
                            </>)
                        }
                    },
                ]
            });
        }
    }

    // input text change handler
    const handleInputChangeFilter = (event) => {
        setFilterOption(inputs => ({ ...filter_option, [event.target.name]: event.target.value }));
    }

    const clear = () => {
        filter_option.status = ''
        filter_option.startDate = ''
        filter_option.endDate = ''
        setFilterOption({ ...filter_option });
        get_invoice_list();
    }
    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>Active Subscriptions</h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                </div>
                            </div>
                            <hr />
                            <div className='row mt-4 mb-3'>
                                <div className='col-sm-2 mb-3'></div>
                                <div className='col-sm-3 mb-3'>
                                    <DatePicker name='startDate' className='form-control'
                                        selected={filter_option.startDate} onChange={(date) => { handleInputChangeFilter({ target: { name: 'startDate', value: date } }) }}
                                        placeholderText="Start Date"
                                        dateFormat="dd/MM/yyyy"
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                </div>
                                <div className='col-sm-3 mb-3'>
                                    <DatePicker name='endDate' className='form-control'
                                        selected={filter_option.endDate} onChange={(date) => { handleInputChangeFilter({ target: { name: 'endDate', value: date } }) }}
                                        placeholderText="End Date"
                                        dateFormat="dd/MM/yyyy"
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                </div>
                                <div className='col-sm-3 mb-3'>
                                    <button type='button' onClick={get_invoice_list} className='btn btn-primary me-3'>Apply</button>
                                    <button type='button' onClick={clear} className='btn btn-danger'>Clear</button>
                                </div>
                            </div>
                            <div className='table-responsive text-nowrap'>
                                <table id="dataTableExample" className="table table-striped">
                                    <thead>
                                        <tr>
                                            <td>Sub Id</td>
                                            <td>User Name</td>
                                            <td>User Email</td>
                                            <td>Plan Name</td>
                                            <td>Amount</td>
                                            <td>Start Date</td>
                                            <td>End Date</td>
                                            <td>Limit</td>
                                            {/* <td>Status</td> */}
                                            {/* <td>Action</td> */}
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SubscriptionList;